export default {
  'messages': {
    'de-DE': {
      'Home_Menu': 'Dashboard',
      'Home': 'Dashboard',
      'parties': 'Konten',
      'PartyList': 'Konten Übersicht',
      'credit_transfers': 'Überweisungen',
      'CreditTransferList': 'Überweisungen Übersicht',
      'credit_transfer_payment_runs': 'Zahlläufe',
      'CreditTransferPaymentRunList': 'Zahlläufe Übersicht',
      'CreditTransferPaymentRunCreate': 'Erstellen',
      'AddTransfers_Menu': 'Überweisung zu Zahllauf',
      'add_transfers_to_runs': 'Überweisung zu Zahllauf',
      'AddTransfersToRunCreate': 'Erstellen',
      'Parties_Menu': 'Konten',
      'CreditTransfers_Menu': 'Überweisungen',
      'CreditTransferPaymentRuns_Menu': 'Zahlläufe',
      'Submit': 'Abschicken',
      'Reset': 'Reset',
      'Delete': 'Löschen',
      'Are you sure you want to delete this item?': 'Wirklich löschen?',
      'No results': 'Keine Ergebnisse',
      'Close': 'Schließen',
      'Cancel': 'Abbrechen',
      'Updated': 'Aktualisiert',
      'Field': 'Feld',
      'Value': 'Wert',
      'Filters': 'Filter',
      'Filter': 'Filter',
      'Data unavailable': 'Daten nicht verfügbar',
      'Loading...': 'Lade...',
      'No data available': 'Keine Ergebnisse gefunden',
      'Deleted': 'Gelöscht',
      'Please, insert a value bigger than zero!': 'Bitte Wert größer Null eintragen',
      'Please type something': 'Bitte etwas tippen',
      'Field is required': 'Feld ist verpflichtend',
      'Records per page': 'Treffer pro Seite:',
      'creator': 'Ersteller',
      'creditTransfers': 'Überweisungen',
      'debtor': 'Debitor',
      'creditor': 'Kreditor',
      'amount': 'Betrag',
      'remittanceInfo': 'Verwendungszweck',
      'currency': 'Währung',
      'endToEndId': 'Ende zu Ende ID',
      'createdAt': 'Erstellt am',
      'processedAt': 'Verarbeitet am',
      'dueAt': 'Ausführen am',
      'totalAmount': 'Gesamtbetrag',
      'Run marked as done!': 'Zahllauf als verarbeitet markiert!',
      'Party List': 'Konten Liste',
      'CreditTransfer List': 'Überweisungs Liste',
      'CreditTransferPaymentRun': 'Zahllauf',
      'CreditTransferPaymentRun List': 'Zahllauf Liste',
      'sepaInfo.name': 'Kontoinhaber',
      'sepaInfo.IBAN': 'IBAN',
      'sepaInfo.BIC': 'BIC',
      'next': 'Weiter',
      'create': 'Erstellen',
      'add': 'Hinzufügen',
    }
  },
  'numbers': {
    'de-DE': {
      currency: {
        'style': 'decimal',
        'minimumFractionDigits': 2,
        'maximumFractionDigits': 2,
      }
    }
  },
  'dates': {
    'de-DE': {
      short: {
        year: '2-digit', month: '2-digit', day: '2-digit'
      },
      long: {
        year: 'numeric', month: 'short', day: 'numeric',
        weekday: 'short', hour: 'numeric', minute: 'numeric'
      }
    }
  }
}
